import { apiClient } from "../../../config/axios.config";
import type { PaginationResponse, Response } from "../../../types/api.types";
import type { getUserByOwnerIdForm, getUserForm, matchUserForm, updateUserForm } from "../dtos/request/user.request";
import type { User } from "../dtos/response/user.response";

const model = "/v1/user";

export const getUserList = async (query: getUserForm): Promise<PaginationResponse<User>> => {
    const { data } = await apiClient.get(model, { params: query });
    return data;
};

export const getUserDetail = async (id: string): Promise<Response<User & { createdDate: string; }>> => {
    const { data } = await apiClient.get(`${model}/${id}`);
    return data;
};

export const updateUser = async (form: updateUserForm) => {
    const { data } = await apiClient.patch(`${model}/${form.id}`, form);
    return data;
};

export const deleteUser = async (id: string) => {
    const { data } = await apiClient.delete(`${model}/${id}`);
    return data;
};

export const matchUser = async (form: matchUserForm): Promise<Response> => {
    const { data } = await apiClient.patch(
        `${model}/match/${form.id}`,
        form.branch
    );
    return data;
};

export const unmatchUser = async (form: matchUserForm) => {
    const { data } = await apiClient.delete(`${model}/unmatch/${form.id}`, {
        data: form.branch,
    } as any);
    return data;
};

export const getUserByOwnerId = async (form: getUserByOwnerIdForm): Promise<PaginationResponse<User>> => {
    const { data } = await apiClient.get(`${model}/ownerId/${form.ownerId}`, { params: form });
    return data;
}
